<script>
import { BListGroup } from "bootstrap-vue";

export default {
  extends: BListGroup
};
</script>